<div class="shimmer-layout">
  <!-- Layout -1 -->
  @switch (layoutType()) { @case ('category-page-layout-1') {
  <!-- original shimmer -->
  <section>
    <div class="category-page-content">
      <div class="left-panel">
        <div class="vertical-filter animate">
          <div class="shimmer-filter-list">
            @for (item of [1, 2, 3, 4, 5, 6, 7, 8, 9]; track item) {
            <div class="shimmer-checkbox animate-inner"></div>
            <div class="shimmer-filter-label animate-inner"></div>
            }
          </div>
        </div>
      </div>

      <div class="right-panel">
        <section class="shimmer-toolbar animate"></section>

        <section class="shimmer-product-list">
          @for (item of [1, 2, 3, 4, 5, 6, 7, 8, 9]; track item) {
          <div class="shimmer-product animate"></div>
          }
        </section>
      </div>
    </div>
  </section>
  } @case ('category-page-layout-2') {
  <!-- category page shimmer-2 -->
  <section>
    <div class="category-page-content">
      <div class="left-panel">
        <div class="horizontal-filter">
          <div class="shimmer-filter-list">
            @for (item of [1, 2, 3, 4]; track item) {
            <div class="shimmer-checkbox animate-inner"></div>
            <div class="shimmer-filter-label animate-inner"></div>
            }
          </div>
        </div>
      </div>

      <div class="right-panel">
        <section class="shimmer-toolbar animate"></section>

        <section class="shimmer-product-list">
          @for (item of [1, 2, 3, 4, 5, 6, 7, 8]; track item) {
          <div class="shimmer-product animate"></div>
          }
        </section>
      </div>
    </div>
  </section>
  } @case ('category-page-layout-3') {
  <!-- Category page shimmer-3 -->
  <section>
    <div class="category-page-content">
      <div class="right-panel">
        <section class="shimmer-toolbar animate"></section>

        <section class="shimmer-product-list">
          @for (item of [1, 2, 3, 4, 5, 6, 7, 8, 9]; track item) {
          <div class="shimmer-product animate"></div>
          }
        </section>
      </div>
      <div class="left-panel">
        <div class="vertical-filter animate">
          <div class="shimmer-filter-list">
            @for (item of [1, 2, 3, 4, 5, 6, 7, 8, 9]; track item) {
            <div class="shimmer-checkbox animate-inner"></div>
            <div class="shimmer-filter-label animate-inner"></div>
            }
          </div>
        </div>
      </div>
    </div>
  </section>
  } }
</div>
